import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { Badge, Layout, Menu } from 'antd'
import Sider from 'antd/lib/layout/Sider'
import Flex from 'components/Flex'
import SideBar from 'components/Sidebar'
import { navItems } from 'modules/Nav/navItems'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { EmptyDivElement } from '../../components/UIComponents/CommonStyledComponent'
import { PermittedNavItems } from '../../utils/permissionsValidation'
import {
  setIsRuleEdited,
  setSelectedDegreesAndDepartmentsList,
} from '../RuleEngine/action'
import { SpaceItem, SubMenuItem } from './Style'
// import { useSelector } from 'react-redux'

const MenuStyle = styled(Menu)`
  .ant-menu-item {
    border-left: 5px solid transparent;
  }
  .ant-menu-item-selected {
    background-color: ${COLORS.GREY_T_10} !important;
    border-left: 5px solid #20308d;
  }

  ::-webkit-scrollbar {
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 50px;
    background: #888;
  }
`

const MenuItem = styled(Menu.Item)`
  &::-webkit-scrollbar {
    display: none;
  }
  .ant-menu-title-content {
    padding-top: ${props =>
      props.pageTitle === 'Approvals' ? '10px' : '8px'};
    padding-bottom: 5px;
  }
`

const MenuTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  color: ${props => props.color};
  padding-left: 13px;
  line-height: 18px;
`

const SubMenuTitle = ({
  navTitle,
  parentPath,
  title,
  anotherMenu,
  pageTitle,
}) => {
  const [render, setRender] = useState(false)
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => {
    setIsOpen(!isOpen)
    role(navTitle)
  }
  const role = data => {
    navigate(`${parentPath}`)
    setRender(!render)
  }
  useEffect(() => {
    if (title) {
      setIsOpen(true)
      setRender(true)
    }
  }, [title])
  useEffect(() => {
    setIsOpen(false)
    setRender(false)
  }, [anotherMenu])
  return (
    <div style={{ lineHeight: 'inherit' }}>
      <SpaceItem onClick={toggleMenu}>
        <div
          style={{
            color: title == navTitle ? 'white' : '',
          }}
        >
          {navTitle}
        </div>
      </SpaceItem>
    </div>
  )
}
const Nav = ({ permissions }) => {
  const NavItem = PermittedNavItems(permissions, navItems)
  
  const instituteDetails = useSelector(
    state => state?.auth?.instituteDetails
  )
  const accessLevel = instituteDetails?.instituteSubscription?.accessLevel

  // Filter NavItem based on accessLevel rules
  // - For accessLevel 0 or 2: show a specific subset; include the v2
  //   Assessment entry only for accessLevel 2
  // - For accessLevel 1: remove the v2 Assessment entry only
  // - For accessLevel 3: show everything
  // The Assessment entry's path is the v2 cockpit (/v2/dashboard), so that is
  // what these rules key on — see modules/Nav/navItems.js.
  let filteredNavItem
  if (accessLevel === 0 || accessLevel === 2) {
    const allowedPaths = [
      '/students', // Students
      '/roles', // PIL Roles
      '/jobRoles', // Job Roles
      '/drives', // PIL Drives
      '/setting', // Settings
      '/courses', // Courses
      '/users', // Users
    ]
    if (accessLevel === 2) {
      allowedPaths.push('/v2/dashboard') // v2 Assessment only for accessLevel 2
    }
    filteredNavItem = NavItem.filter(item => allowedPaths.includes(item.path))
  } else {
    // For accessLevel 1: exclude v2 Assessment; for accessLevel 3: keep everything
    filteredNavItem = NavItem.filter(item =>
      accessLevel === 1 ? item.path !== '/v2/dashboard' : true
    )
  }
  const [collapsed, setCollapsed] = useState(false)
  const dispatch = useDispatch()
  const urgentRequestCount = useSelector(
    state => state?.tpoRequest?.tpoMetrics?.urgent_count
  )
  const studentsMetrics = useSelector(
    state => state?.institute?.studentsMetrics
  )
  
  const combinedUrgentCount = (Number(urgentRequestCount) || 0) + 
    (Number(studentsMetrics?.optOut_pending) || 0) + 
    (Number(studentsMetrics?.approval_pending_count) || 0)
  // const fetchMetrics = async () => {
  //   const metrics = await getTPOMetrics()
  //   setMetricsData(metrics)
  // }

  // useEffect(() => {
  //   fetchMetrics()
  // }, [])

  // const reportsSubMenu = [...NavItem]
  //   .find(f => f.path === '/reports')
  //   ?.externalMenu?.filter(item => !item?.hidden)
  const location = useLocation()
  const navigate = useNavigate()
  const [menuType] = useState('GlobalMenu')
  const [externalMenuOpen, setExternalMenuOpen] = useState(false)
  const [title, setTitle] = useState('')
  const getMenu = navItem =>
    navItem
      ?.filter(nav => !nav?.hidden)
      ?.map(item => {
        return (
          <>
            <MenuItem
              key={item.path}
              path={item.path}
              pageTitle={item.pageTitle}
              onClick={() => {
                // if (item.path === '/reports' && (collapsed || autoCollapse)) {
                //   setCollapsed(false)
                //   setAutoCollapse(false)
                // }
              }}
            >
              <Flex centerVertically>
                {item.pageTitle === 'Approvals' ? (
                  <Badge
                    size="small"
                    count={combinedUrgentCount}
                    // offset={[-2, -1]}
                  >
                    <item.icon
                      color={
                        location.pathname?.includes(item?.path)
                          ? 'white'
                          : '#999FAC'
                      }
                    />
                  </Badge>
                ) : (
                  <item.icon
                    color={
                      location.pathname?.includes(item?.path)
                        ? 'white'
                        : '#999FAC'
                    }
                  />
                )}
                {!(collapsed || autoCollapse) && (
                  <MenuTitle
                    color={
                      location.pathname?.includes(item?.path)
                        ? 'white'
                        : '#999FAC'
                    }
                  >
                    {item?.pageTitle}
                    {/* {item.pageTitle == 'Reports' && (
                      <>
                        {externalMenuOpen ? (
                          <DownOutlined
                            style={{
                              marginLeft: '20px',
                              color: 'white',
                            }}
                          />
                        ) : (
                          <UpOutlined style={{ marginLeft: '20px' }} />
                        )}
                      </>
                    )} */}
                  </MenuTitle>
                )}
              </Flex>
            </MenuItem>
            {/* {item.path === '/reports' && externalMenuOpen ? (
              <SubMenuItem>
                {reportsSubMenu?.map(({ subMenu, path, navTitle }) => {
                  return (
                    <EmptyDivElement
                      key={path}
                      onClick={e => {
                        setTitle(navTitle)
                        navigate(`${path}`)
                      }}
                    >
                      <SubMenuTitle
                        navTitle={navTitle}
                        subMenu={subMenu}
                        title={title}
                        parentPath={path}
                      />
                    </EmptyDivElement>
                  )
                })}
              </SubMenuItem>
            ) : null} */}
          </>
        )
      })

  const onItemClick = ({ item: { props } }) => {
    const { path } = props

    if (!path?.includes('newRole') && !path?.includes('editRole')) {
      localStorage.removeItem('jdDetails')
      localStorage.removeItem('jdFile')
      localStorage.removeItem('crossedStep')
    }
    // Strangler-fig: any path that lives under the v2 Next app (/v2/...)
    // must do a full browser navigation, not a react-router SPA navigate.
    // SPA-navigating would route the request through this v1 router, which
    // has no matching route for /v2/* (only the catch-all 404), and would
    // render the 404 inside the v1 SPA shell instead of the v2 page. A hard
    // navigation hands the URL to the browser, which sends it to nginx and
    // (via the /v2 location block) to the v2 server.
    if (path?.startsWith('/v2/')) {
      window.location.href = path
      return
    }
    if (path === '/reports') {
      navigate(path)
      setTitle('')
      setExternalMenuOpen(false)
    } else {
      navigate(path)
      setTitle('')
      setExternalMenuOpen(false)
    }
    dispatch(setIsRuleEdited(false))
    dispatch(
      setSelectedDegreesAndDepartmentsList({
        check: false,
        list: [],
      })
    )
  }

  const getSelectedkey = () => {
    if (location.pathname?.includes('roles/details')) {
      return [`/roles`]
    } else if (location.pathname?.includes('dashboard/roles')) {
      return [`/dashboard`]
    } else if (location.pathname?.includes('jobRoles')) {
      return [`/jobRoles`]
    } else if (location.pathname?.includes('events')) {
      return [`/events`]
    } else if (location.pathname?.includes('ruleEngine')) {
      return [`/ruleEngine`]
    } else {
      return [location.pathname]
    }
  }
  const [autoCollapse, setAutoCollapse] = useState(false)
  useEffect(() => {
    const handleResize = () => {
      const isSmallScreen = window.innerWidth < 900
      setAutoCollapse(window.innerWidth < 900)
      if (isSmallScreen) {
        setExternalMenuOpen(false)
      }
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  const handleCollapseClick = value => {
    setCollapsed(value)
    setExternalMenuOpen(false)
  }
  return (
    <SideBar>
      <Layout>
        <Sider
          collapsible
          collapsed={collapsed ?? autoCollapse}
          onCollapse={value => handleCollapseClick(value)}
          style={{ fontSize: '20px' }}
        >
          <MenuStyle
            selectedKeys={getSelectedkey()}
            theme="dark"
            mode="inline"
            style={{
              height: '90vh',
              overflow: 'auto',

              paddingBottom: '5rem',
            }}
            inlineIndent={24}
            onClick={onItemClick}
          >
            {getMenu(filteredNavItem.filter(e => e.menuType === menuType))}
          </MenuStyle>
        </Sider>
      </Layout>
    </SideBar>
  )
}
export default Nav
